import './entity-history.scss'

import { defineComponent } from 'vue'
import { BvTableFieldArray } from 'bootstrap-vue'

import { map } from '@skinsoft/data-store'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'

export interface HistoryRecord {
    author?: string | Error | null;
    date?: Date;
    description: string;
    id: string;
    title: string;
}

export const EntityHistory = defineComponent({
    mixins: [reactiveVueMixin],
    props: [
        'emptyMessage',
        'entityDataStore',
        'historyStates',
        'sortFields',
        'title',
        'targetRouteName',
        'serializer',
    ],
    template: require('./entity-history.html'),
    data() {
        return {
            records: [] as HistoryRecord[],
        }
    },
    computed: {
        fields(): BvTableFieldArray {
            return [
                {
                    key: 'title',
                    label: this.$t('entityHistory.field.title').toString(),
                    tdAttr: {
                        "data-cy": "entity-history-data-title"
                    }
                },
                {
                    key: 'author',
                    label: this.$t('entityHistory.field.author').toString(),
                    tdAttr: {
                        "data-cy": "entity-history-author"
                    }
                },
                {
                    formatter: value => (this.$i18n as any).d(value),
                    key: 'date',
                    label: this.$t('entityHistory.field.date').toString(),
                    sortDirection: 'desc',
                    tdAttr: {
                        "data-cy": "entity-history-date"
                    }
                },
            ];
        },
    },
    created() {
        this.subscribe();
    },
    methods: {
        subscribe() {
            this.subscribeTo(
                this.entityDataStore
                    .fetchAll({
                        query: {
                            ...(this.historyStates.length > 0 && {
                                states: this.historyStates.join(','),
                            }),
                            sortAsc: 'false',
                            ...(this.sortFields.length > 0 && {
                                sortFields: this.sortFields.join(','),
                            }),
                        },
                        userScope: true,
                    })
                    .pipe(map(this.serializer)),
                records => {
                    this.records = records;
                },
                'history',
            );
        },
        unsubscribe() {
            this.unsubscribeFrom('history');
        },
        onRowClik(record: HistoryRecord) {
            const index = this.records.findIndex(i => i.id === record.id);
            const next = this.records.filter((_, k) => k > index).map(v => v.id);
            const query: Record<string, string> = { next: next as any };

            const params: Record<string, string> = { id: record.id };
            return this.$router.push({
                name: this.targetRouteName,
                params,
                query,
            });
        },
    },
    watch: {
        entityDataStore() {
            this.unsubscribe();
            this.subscribe();
        },
    },
})
